import { getDictPhrase } from "../../helpers";
export const getDateOptions = (dates, selectedDate, dict, dictDates) => {
    return dates.map((date, index) => ({
        value: `${date.toString()}#${index}`,
        label: `${getDictPhrase(dict, `day-${dictDates[index].getDay()}`)} ${("0" + dictDates[index].getDate()).slice(-2)} ${getDictPhrase(dict, `month-${dictDates[index].getMonth()}`)}`,
        selected: date.getDate() === selectedDate.getDate()
    }));
};
//# sourceMappingURL=getDateOptions.js.map